import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Card from 'assets/components/card/Card';
import ThemeCardComment from 'assets/components/card/themes/Theme.Card.Comment';
import Collection from 'assets/components/data/Collection';
import useForm from 'assets/components/form/hooks/Form';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import Sanitizer from 'assets/components/textBox/Sanitizer';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import { isEmpty, orderBy } from 'lodash';
import User from 'models/core/user/Model.User';
import { AccountReceivableForm } from '../../Finance.AccountReceivable.Hooks';

const FinanceAccountReceivableEditNotes = () => {
  const { lang } = getLocales();
  const { userId, user } = useAuthStore();
  const { form } = useModalForm<AccountReceivableForm>();

  const commentForm = useForm<
    Utils.FormData<Model.IAccountReceivableComment & { tempCreatedAtUtcUnix: number; createdAtUtc: string; user: User }>
  >({
    default: {
      comment: undefined,
      user: user,
      userId: userId,
      accountReceivableId: form.data?.id,
      createdAtUtc: date().format(defaultServerDateTimeFormat),
      tempCreatedAtUtcUnix: date().unix(),
    },
    onSubmit: async (newComment) => {
      const updatedComments = [...(form.data?.accountReceivableComments ?? []), newComment];
      form.merge({ accountReceivableComments: updatedComments });

      commentForm.reload();
    },
    validation: (data, errors) => {
      if (!data.comment) errors.comment = lang.required;
    },
  });

  return (
    <FormWrapper>
      <div style={{ display: 'flex', flexDirection: 'column', gap: Theme.Size.L }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: Theme.Size.M,
          }}
        >
          {isEmpty(form.data.accountReceivableComments) && <ErrorWrapper children={lang.noNotes} />}
          <Collection
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: Theme.Size.S,
            }}
            data={orderBy(form.data.accountReceivableComments || [], (it) => it.tempCreatedAtUtcUnix, ['asc'])}
            map={({ data: comment, index }) => (
              <Card
                info={localizeDate(comment?.createdAtUtc, defaultDateTimeFormat)}
                title={comment.user?.displayInfo?.title}
                media={<Icon class="fas-user" />}
                subtitle={<Sanitizer text={comment?.comment} />}
                class={ThemeCardComment}
                actions={
                  <>
                    <Button
                      class={ThemeButtonCircle}
                      htmlElementProps={{ title: lang.delete }}
                      onClick={() => {
                        form.update({
                          accountReceivableComments: form.data?.accountReceivableComments?.filter(
                            (_, i) => i !== index
                          ),
                        });
                      }}
                      media={<Icon class="fas-trash" />}
                    />
                  </>
                }
              />
            )}
          />
          <div>
            <MultilineTextInput name="comment" value={commentForm.data.comment} onChange={commentForm.update} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: Theme.Size.M }}>
              <Button
                class={ThemeButtonCircle}
                onClick={commentForm.submit}
                render={lang.addComent}
                disabled={commentForm.hasErrors || commentForm.isSubmitted}
                active={!commentForm.hasErrors}
                isLoading={commentForm.isSubmitted}
                media="fas-paper-plane"
              />
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  );
};

export default FinanceAccountReceivableEditNotes;
